export const GOLD = "Gold"
export const GREEN = "Green"



// WEBPACK FOOTER //
// ./src/constants/tierCode.js